import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductTooltipComponent} from './product-tooltip.component';
import {MatMenuModule, MatTooltipModule, MatIconModule} from '@angular/material';
import { ProductNamePipeModule } from 'src/app/pipes/product-name/product-name.pipe.module';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
    declarations: [
        ProductTooltipComponent
    ],
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        ProductNamePipeModule,
        TranslateModule
    ],
    exports: [
        ProductTooltipComponent
    ]
})
export class ProductTooltipModule {
} 